<template>
  <div class="alertbgout" v-if="warningId && isShowWarningBox">
    <!-- 预警弹窗 -->
    <div class="outlinebg" v-if="showClose">
      <div class="titleLine">
        <div style="display: flex; align-items: center">
          <span class="line"></span>
          <span>预警</span>
        </div>
        <div class="closemap" @click="close"></div>
      </div>
      <!-- 主要信息展示 -->
      <div class="infoBox">
        <!-- 左边地图 -->
        <div class="mapBox">
          <div
            ref="map-mapview"
            class="map"
            style="width: 100%; height: 100%; z-index: 2"
          ></div>
          <div class="coverbg"></div>
        </div>
        <!-- 右边信息展示 -->
        <div class="infoRight" style="height: 100%">
          <ul>
            <li>
              <span class="lefttxt">报警级别：</span>
              <span class="righttxt">{{
                getLevel(alarmInfo.AlerteLevel)
              }}</span>
            </li>
            <li>
              <span class="lefttxt">报警类型：</span>
              <span class="righttxt">{{ getType(alarmInfo.AlertType) }}</span>
            </li>
            <li>
              <span class="lefttxt">报警内容：</span>
              <el-tooltip placement="top">
                <div slot="content">
                  {{ alarmInfo.Content }}
                </div>
                <span class="righttxt">{{ alarmInfo.Content }}</span>
              </el-tooltip>
            </li>
            <li>
              <span class="lefttxt">报警时间：</span>
              <span class="righttxt">{{
                formatDate(alarmInfo.BeginDate)
              }}</span>
            </li>
            <li>
              <span class="lefttxt">报警地点：</span>
              <span class="righttxt">{{ alarmInfo.Location }}</span>
            </li>
            <li>
              <span class="lefttxt">报警来源：</span>
              <span class="righttxt">{{ alarmInfo.SourceDesc }}</span>
            </li>
          </ul>
          <div class="alarmBtnDiv">
            <el-button size="big" @click="goDetailInfo">接报处理</el-button>
          </div>
        </div>
      </div>

      <el-dialog
        title="预警受理"
        v-if="dialogAlertInfoVisible"
        :visible.sync="dialogAlertInfoVisible"
        custom-class="customClass"
        width="80%"
        :before-close="handleClose"
        :append-to-body="true"
        style="text-align: left"
        :destroy-on-close="true"
      >
        <elary-warning-info
          @clickCancel="handleDialogCancel"
          :ResourcesId="ResourcesId"
          @refresh="search"
        ></elary-warning-info>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MyApis from "../../api/src/earlyMsg.js";
import MapCenterApi from "../../api/src/MapCenter.js";

export default {
  name: "ElaryWarningBox",
  // controller: "UI",
  // action: "ElaryWarningInfoList",

  data() {
    return {
      showClose: true,

      toUrl: "/plugin/emergency/ui/onemap",
      loadingText: "加载中...",
      mapInstance: null,
      dialogVisible1: false,
      dialogVisible2: false,
      marker: null,
      lat: "",
      lng: "",
      center: [],
      center2: [],
      alarmInfo: {},
      AlerteLevelArr: [],
      AlertTypeArr: [],
      isHavePosition: false,
      isVideoMonitorDialogVisible: false,
      streamType: 1, //0 - 主码流；1 - 子码流
      autoplay: true,
      cameraId: "",
      cameraName: "",
      deviceInfo: {},
      dialogAlertInfoVisible: false,
      isSoSMonitorDialogVisible: false,
      ResourcesId: "",
    };
  },
  props: ["warningId"],
  // props:{
  //    warningId:String
  // },
  watch: {
    warningId: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        if (val !== oldVal && val != "") {
          this.search();
          this.onDrawMap();
          this.$store.state.isShowWarningBox = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created: function () {
    this.alarmLevel();
    this.getAlarmType();
  },
  mounted: function () {
    //  debugger;
    // this.onDrawMap();
  },
  computed: {
    isShowWarningBox() {
      return this.$store.state.isShowWarningBox;
    },
  },
  methods: {
    getLevel: function (value) {
      let result = "";
      let AlerteLevelArr = this.AlerteLevelArr;
      AlerteLevelArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    getType: function (value) {
      let AlertTypeArr = this.AlertTypeArr;
      let result = "";
      AlertTypeArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    close() {
      // this.showClose = false;
      this.warningId = "";
    },

    queryMonitor() {
      this.cameraId = this.deviceInfo.DeviceId;
      this.cameraName = this.deviceInfo.DeviceName;
      this.cameraIsOnline = this.deviceInfo.IsOnline;
      this.isSoSMonitorDialogVisible = true;
    },
    goDetailInfo() {
      let path = `/plugin/serviceAlarm/UI/ElaryWarningInfo?Id=${this.warningId}`;
      // this.close();
      console.log(this.$store);
      this.$store.state.isShowWarningBox = false;
      this.$router.push(path);
    },
    search() {
      let that = this;
      let ResourcesId = this.warningId;
      if (ResourcesId) {
        let searchInfo = {
          Id: ResourcesId,
        };
        new MyApis()
          .GetItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            that.alarmInfo = r;
            if (that.alarmInfo.AlertType === "0") {
              that.deviceInfo = JSON.parse(that.alarmInfo.Content);
              that.alarmInfo.Content = "SOS报警——" + that.deviceInfo.DeviceName;
              that.alarmInfo.SourceDesc = "报警柱";
              if (
                that.deviceInfo.Longitude &&
                (that.deviceInfo.Latitude || that.deviceInfo.Laitude) &&
                that.deviceInfo.Longitude != "0" &&
                (that.deviceInfo.Latitude != "0" ||
                  that.deviceInfo.Laitude != "0")
              ) {
                that.center2.push(that.deviceInfo.Longitude);
                that.center2.push(
                  that.deviceInfo.Latitude || that.deviceInfo.Laitude
                );
                that.isHavePosition = true;
              } else {
                that.getMapCenter();
                that.isHavePosition = false;
              }
            } else {
              if (
                that.alarmInfo.Longitude &&
                (that.alarmInfo.Latitude || that.alarmInfo.Laitude) &&
                that.alarmInfo.Longitude != "0" &&
                (that.alarmInfo.Latitude != "0" ||
                  that.alarmInfo.Laitude != "0")
              ) {
                that.center2.push(that.alarmInfo.Longitude);
                that.center2.push(
                  that.alarmInfo.Latitude || that.alarmInfo.Laitude
                );
                that.isHavePosition = true;
              } else {
                that.getMapCenter();
                that.isHavePosition = false;
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    clearsearch() {
      this.TranresourcesType = "";
      this.ResourceName = "";
    },

    getMapCenter() {
      let searchInfo = {
        SysCode: "ZJMap",
        Key: "DefaultCenter",
      };
      new MapCenterApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          this.center2 = r.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    goCenter: function () {
      let that = this;
      // eslint-disable-next-line no-undef
      if (this.center2.length > 0) {
        // eslint-disable-next-line no-undef
        this.mapInstance.panTo(
          // eslint-disable-next-line no-undef
          new BMap.Point(this.center2[0], this.center2[1])
        );

        setTimeout(() => {
          if (that.isHavePosition) {
            that.addDom();
          } else {
            that.addMarker(that.mapInstance, that.center);
          }
        }, 1000);
      } else {
        this.getMapCenter();
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          this.mapInstance.panTo(
            // eslint-disable-next-line no-undef
            new BMap.Point(this.center2[0], this.center2[1])
          );
          if (that.isHavePosition) {
            that.addDom();
          } else {
            that.addMarker(that.mapInstance, that.center);
          }
        }, 2000);
      }
    },
    onDrawMap: function () {
      // 创建地图，并通过样式让地图填满窗口

      let that = this;
      var mapConfigs = {};
      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "EmergencyOneMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            // eslint-disable-next-line no-undef
            mapConfigs: $.extend(
              {},
              {
                togglePanelVisiable: false,
                mapLayers: "DOM",
                clickToShowLocation: false,
                // reportGeo: true,
                // onGotGeo: function(e) {
                //   e.handled = true;
                //   if (that.marker) {
                //     that.marker.setPosition(
                //       e.map.newPoint(e.point.lng, e.point.lat)
                //     );
                //   } else {
                //     that.marker = that.addMarker(e.map, e.point);
                //   }
                //   that.dialogVisible2 = true;
                //   that.lat = e.point.lat;
                //   that.lng = e.point.lng;
                // },
                onMapCreated: function (e) {
                  // console.log("e")
                  // console.log(e)
                  that.mapInstance = e.map;
                  // e.map.clearAll();
                  that.center = e.map.config.center;
                  that.goCenter();
                  // setTimeout(() => {
                  //   that.addDom();
                  // }, 1000);
                },
                // eslint-disable-next-line no-unused-vars
                onGettingLayerData: function (e) {
                  // console.log({
                  //   funName: "onGettingLayerData",
                  //   data: that.center,
                  // });
                  // eslint-disable-next-line no-undef
                  e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
                    Longitude: that.center[0],
                    Latitude: that.center[1],
                  });
                },
              },
              mapConfigs
            ),
          });
        });
      });
    },
    addMarker: function (map, point) {
      if (!map) return null;
      this.marker = map.createOverlay(
        point,
        {
          url: "/lib/zjmap/Content/images/noposition.png",
          width: 100,
          height: 75,
          offsetX: 24,
          offsetY: 48,
        },
        null,
        {
          enableClicking: false,
        }
      );
      map.addOverlay(this.marker);
      return this.marker;
    },
    addDom: function () {
      if (!this.mapInstance) return;
      var layer = this.mapInstance.getLayerByName("DOM");
      if (layer && layer.addDom) {
        // eslint-disable-next-line no-undef
        var $div = $("<div></div>");
        $div.append(this.getSvgContent());
        $div.css({
          width: "30rem",
          height: "30rem",
          "margin-left": "-15rem",
          "margin-top": "-15rem",
          position: "absolute",
        });
        layer.addDom(this.center2[0], this.center2[1], $div[0]);
      }
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    //日期列表展示格式
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then((d) => {
          this.AlerteLevelArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("BusinessAlarm:AlertType", "")
        .then((d) => {
          this.AlertTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
};
</script>
<style type="text/css" scoped="true">
.fontRed {
  color: red;
}
.fontYellow {
  color: yellow;
}
.fontBlue {
  color: blue;
}
.fontOrange {
  color: orange;
}
.outlinebg {
  width: 1060px;
  height: 568px;
  background: url("../../assets/alertbg.png") no-repeat;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -530px;
  margin-top: -284px;
  z-index: 100;
  padding: 0px 64px;
}
.titleLine {
  height: 65px;
  line-height: 65px;
  font-size: 18px;
  color: #2ac1ff;
  padding: 0px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.line {
  display: inline-block;
  width: 2px;
  height: 18px;
  background: #2ac1ff;
  margin-right: 5px;
}
.closemap {
  width: 16px;
  height: 16px;
  background: url("../../assets/close.png") no-repeat;
}
.infoBox {
  display: flex;
  align-items: center;
  padding: 0px 10px 0 0px;
  box-sizing: border-box;
  color: #333;
}
.mapBox {
  width: 525px;
  height: 474px;
  padding: 24px 20px 16px 26px;
  box-sizing: border-box;
  position: relative;
}
.coverbg {
  width: 525px;
  height: 474px;
  background: url("../../assets/mapborder.png") no-repeat;
  background-size: 525px 474px;
  position: absolute;
  left: 0px;
  top: 0px;
}
.infoRight {
  width: 325px;
  margin-left: 20px;
}
.infoRight li {
  list-style: none;
  font-size: 16px;
  height: 36px;
  line-height: 36px;
  color: #fff;
  width: 325px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
/* .alarmBtn{
    margin-left: 100px;
    margin-top: 60px;
    width: 100px;
    background: #298beb;
  } */
/* .alarmBtnDiv{
    margin-top: 60px;
    width: 100px;
  } */
.alertbgout {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 99;
}
/deep/.el-dialog .el-dialog__header {
  text-align: left !important;
}
</style>